var _defs, _g;
var _excluded = ["title", "titleId"];
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
function _objectWithoutProperties(e, t) { if (null == e) return {}; var o, r, i = _objectWithoutPropertiesLoose(e, t); if (Object.getOwnPropertySymbols) { var n = Object.getOwnPropertySymbols(e); for (r = 0; r < n.length; r++) o = n[r], -1 === t.indexOf(o) && {}.propertyIsEnumerable.call(e, o) && (i[o] = e[o]); } return i; }
function _objectWithoutPropertiesLoose(r, e) { if (null == r) return {}; var t = {}; for (var n in r) if ({}.hasOwnProperty.call(r, n)) { if (-1 !== e.indexOf(n)) continue; t[n] = r[n]; } return t; }
import * as React from "react";
function SvgCoin1(_ref, svgRef) {
  var title = _ref.title,
    titleId = _ref.titleId,
    props = _objectWithoutProperties(_ref, _excluded);
  return /*#__PURE__*/React.createElement("svg", _extends({
    xmlns: "http://www.w3.org/2000/svg",
    xmlnsXlink: "http://www.w3.org/1999/xlink",
    viewBox: "0 0 132.3 109.02",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _defs || (_defs = /*#__PURE__*/React.createElement("defs", null, /*#__PURE__*/React.createElement("style", null, ".cls-1{isolation:isolate;}.cls-2{fill:url(#linear-gradient);}.cls-3{fill:url(#linear-gradient-2);}.cls-4,.cls-6{mix-blend-mode:screen;}.cls-4{fill:url(#linear-gradient-3);}.cls-5{fill:url(#linear-gradient-4);}.cls-6{fill:url(#linear-gradient-5);}.cls-7{fill:#99570e;}"), /*#__PURE__*/React.createElement("linearGradient", {
    id: "linear-gradient",
    x1: -94.32,
    y1: 1453.87,
    x2: 49.07,
    y2: 1453.87,
    gradientTransform: "translate(-775.56 -1142.28) rotate(-36)",
    gradientUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("stop", {
    offset: 0,
    stopColor: "#ffd66b"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.14,
    stopColor: "#ffeb65"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.22,
    stopColor: "#d87f20"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.35,
    stopColor: "#d87f20"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.47,
    stopColor: "#6c440f"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.6,
    stopColor: "#6c440f"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.64,
    stopColor: "#ffeb65"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.73,
    stopColor: "#ffeb65"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.81,
    stopColor: "#d87f20"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.92,
    stopColor: "#ffd66b"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "#da9528"
  })), /*#__PURE__*/React.createElement("linearGradient", {
    id: "linear-gradient-2",
    x1: -22.63,
    y1: 1495.97,
    x2: -22.63,
    y2: 1458.38,
    gradientTransform: "translate(95.94 -1410.78)",
    gradientUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("stop", {
    offset: 0,
    stopColor: "#ffeb74"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "#ffd86c"
  })), /*#__PURE__*/React.createElement("linearGradient", {
    id: "linear-gradient-3",
    x1: -94.32,
    y1: 1466.16,
    x2: 49.07,
    y2: 1466.16,
    gradientTransform: "translate(-775.56 -1142.28) rotate(-36)",
    xlinkHref: "#linear-gradient-2"
  }), /*#__PURE__*/React.createElement("linearGradient", {
    id: "linear-gradient-4",
    x1: -22.63,
    y1: 1491.07,
    x2: -22.63,
    y2: 1458.84,
    gradientTransform: "translate(95.94 -1410.78)",
    gradientUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("stop", {
    offset: 0,
    stopColor: "#ffc74e"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "#ff984d"
  })), /*#__PURE__*/React.createElement("linearGradient", {
    id: "linear-gradient-5",
    x1: -76.85,
    y1: 1478.69,
    x2: 31.6,
    y2: 1478.69,
    gradientTransform: "translate(-775.56 -1142.28) rotate(-36)",
    xlinkHref: "#linear-gradient-4"
  }))), _g || (_g = /*#__PURE__*/React.createElement("g", {
    className: "cls-1"
  }, /*#__PURE__*/React.createElement("g", {
    id: "Layer_2",
    "data-name": "Layer 2"
  }, /*#__PURE__*/React.createElement("path", {
    className: "cls-2",
    d: "M48.29,29.94C16.26,53.22-4.92,78.67,1,86.8l14.32,19.71,116-84.29L117,2.51C111.08-5.62,80.33,6.66,48.29,29.94Z"
  }), /*#__PURE__*/React.createElement("ellipse", {
    className: "cls-3",
    cx: 73.31,
    cy: 64.37,
    rx: 71.69,
    ry: 18.18,
    transform: "translate(-23.83 55.39) rotate(-36)"
  }), /*#__PURE__*/React.createElement("path", {
    className: "cls-4",
    d: "M63.08,50.29c31.82-23.13,62.27-35.54,68.34-27.9,0-.06-.07-.12-.11-.17-5.91-8.12-36.66,4.16-68.69,27.44S9.41,98.39,15.31,106.51c0,0,.09.1.13.16C10.05,98.54,31.26,73.41,63.08,50.29Z"
  }), /*#__PURE__*/React.createElement("ellipse", {
    className: "cls-5",
    cx: 73.31,
    cy: 64.37,
    rx: 54.25,
    ry: 13.76,
    transform: "translate(-23.83 55.39) rotate(-36)"
  }), /*#__PURE__*/React.createElement("path", {
    className: "cls-6",
    d: "M29.22,95.93c5,5.52,27.9-3.75,51.72-21.06s39.71-36.22,36-42.69c-1.33-1.47-3.92-1.89-7.46-1.4C105.18,39.66,92,53.23,74.46,66S40,87,30.19,88.4C28.63,91.61,28.23,94.21,29.22,95.93Z"
  }), /*#__PURE__*/React.createElement("path", {
    className: "cls-7",
    d: "M110.29,30.68c-3.93,8.86-17.39,22.83-35.37,35.9S39.49,88.13,29.85,89.13c-1.36,3.08-1.58,5.54-.42,7.13,4.46,6.14,27.73-3.15,52-20.76s40.26-36.88,35.8-43C116,30.89,113.64,30.34,110.29,30.68Z"
  })))));
}
var ForwardRef = /*#__PURE__*/React.forwardRef(SvgCoin1);
export default __webpack_public_path__ + "static/media/coin1.db4784dcec7f42dd28a716d328bfcc53.svg";
export { ForwardRef as ReactComponent };